



























import SettingsGeneral from "@/components/analytics/SettingsGeneral.vue";
import SettingsCredentials from "@/components/analytics/SettingsCredentials.vue";
import { Settings, Features } from "@/types/settings";
import { DataStatus } from "@/types/common";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { SettingsGeneral, SettingsCredentials } })
export default class SettingsView extends Vue {
  created() {
    this.setIntrospectionStatus();
  }

  @Getter("settings/activeCacheSettings") settings!: Settings;
  @Getter("settings/activeCacheSettingsStatus") settingsStatus!: DataStatus;
  @Getter("settings/activeCacheFeatures") features!: Features;

  introspectionEnabled = false;

  get introspectionTitle() {
    return this.introspectionEnabled ? "Disable Introspection" : "Enable Introspection";
  }

  setIntrospectionStatus(): void {
    if (this.features["debug-mode"] === 2) {
      this.introspectionEnabled = true;
    } else if (this.features["debug-mode"] === -2) {
      this.introspectionEnabled = false;
    }
  }

  toggleIntrospection() {
    this.$ga.button(this.introspectionTitle);
    this.$store.dispatch("settings/toggleIntrospection").then(() => this.setIntrospectionStatus());
  }
}
